
//import Chatbot from '@/components/services/chatbot/Index.vue'
import param from '~/utils/url/param'
import LayoutMenu from './Menu.vue'
import mixins from './mixins.js'
export default {
  name: 'LayoutNavigation',
  //components: { LayoutMenu, Chatbot },
  components: { LayoutMenu },
  mixins: [mixins],
  props: {
    theme: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      expand: null
    }
  },
  watch: {
    drawerMini() {
      this.expand = this.drawerMini ? !0 : !1
    }
  },
  mounted() {
    this.expand = this.drawerMini
  },
  methods: {
    toggleDark() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      this.$store.dispatch('app/toggleDark', this.$vuetify.theme.dark)
    },
    openWhats() {
      window.open(
        'https://api.whatsapp.com/send' +
          param({
            phone: '55' + site.whatsapp.replace(/[^0-9]+/g, ''),
            text: 'Quero marcar uma consulta pelo whatsapp'
          }),
        '__blank'
      )
    }
  }
}
